// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  IRoleApi,
  IRoleApiRequest,
  IRoleApiGetListAttrs,
  IRoleApiSaveAttrs,
  IRoleApiGetDropdownAttrs,
  IRoleApiGetDetailAttrs,
  IRoleApiListResponse,
  IRoleApiDetailResponse,
  IRoleApiNullResponse,
  IRoleApiDropdownResponse,
} from 'interfaces/back-office/master/role/role-api.interface'
// eslint-disable-next-line
import { IBaseApiRequestPayload } from 'interfaces/api'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'

export class RoleApi extends BaseApi<IRoleApi> implements IRoleApiRequest {
  readonly url = ApiConstant.MASTER_ROLE_URL
  private roleUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE)

  /**
   * @description Get list of roles
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IRoleApiGetListAttrs} payload
   *
   * @return {Promise<IRoleApiListResponse>} Promise<IRoleApiListResponse>
   */
  async masterRole_getList(payload: IRoleApiGetListAttrs): Promise<IRoleApiListResponse> {
    return this.POST(`${this.roleUrl}/list`, { ...payload.body }, { ...payload.requestConfig })
  }

  /**
   * @description Get detail role
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IRoleApiGetDetailAttrs} payload
   *
   * @return {Promise<IRoleApiDetailResponse>} Promise<IRoleApiDetailResponse>
   */
  async masterRole_getDetail(payload: IRoleApiGetDetailAttrs): Promise<IRoleApiDetailResponse> {
    return this.POST(`${this.roleUrl}/${payload.params.id}`, {}, { ...payload.requestConfig })
  }

  /**
   * @description Save Roles
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IRoleApiSaveAttrs} payload
   *
   * @return {Promise<IRoleApiNullResponse>} Promise<IRoleApiNullResponse>
   */
  async masterRole_save(payload: IRoleApiSaveAttrs): Promise<IRoleApiNullResponse> {
    const requestPayload: IBaseApiRequestPayload = {
      method: 'POST',
      url: payload.params?.id ? `${this.roleUrl}/update/${payload.params.id}` : `${this.roleUrl}/create`,
    }
    return this[requestPayload.method](requestPayload.url, payload.body, { ...payload.requestConfig })
  }

  /**
   * @description Get role dropdown
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IRoleApiGetDropdownAttrs} payload
   *
   * @return {Promise<IRoleApiDropdownResponse>} Promise<IRoleApiDropdownResponse>
   */
  async masterRole_getDropdown(payload: IRoleApiGetDropdownAttrs): Promise<IRoleApiDropdownResponse> {
    return this.POST(`${this.roleUrl}/dropdown`, {}, { ...payload.requestConfig })
  }
}
